import { Box, useTheme } from "@mui/system";
import { useNavigate } from "react-router-dom";
import { capitalizeFirstLetter } from "../../utils/utils";
import { useState } from "react";
import { Tab, Tabs, Typography } from "@mui/material";
import ClientActionItem from "../Client/ClientActionItem";
import arrowBackSvg from "../../assets/common/arrow-back.svg";
import ClientSearchMeetingView from "./ClientSearchMeetingView";

const GlobalSearchClientPage = () => {
  const theme = useTheme();
  const clientDomain = sessionStorage.getItem('clientDomain');
  const navigate = useNavigate();
  const nameFromEmail = clientDomain ? clientDomain.split(".")[0] || "" : "";
  const formattedName = capitalizeFirstLetter(nameFromEmail);
  const [tabValue, setTabValue] = useState(0);
  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };
  const handleBack = () => {
    const previousPage = sessionStorage.getItem('previousPage');
    if (previousPage) {
      navigate(previousPage);
    } else {

      navigate('/home');
    }
  };


  return (
    <Box className="meetingsContent w-full">
      <Box
        sx={{
          height: "100%",
          padding: "15px",
          [theme.breakpoints.down("lg")]: {
            padding: "10px",
          },
          border: `2px solid ${theme.palette.secondary.main}`,
          borderRadius: "22px",
          background: "#FFFFFF",
        }}
      >
        <Box className="flex flex-row justify-start items-center gap-2 cursor-pointer"
          onClick={handleBack}>
          <img src={arrowBackSvg} />
          <Typography variant="h6">
            {tabValue === 0
              ? `search results for '${formattedName}'`
              : `search results for '${formattedName}'`}
          </Typography>
        </Box>
        <Tabs value={tabValue} onChange={handleTabChange}>
          <Tab label="Meetings" />
          <Tab label="Tasks" />
        </Tabs>
        <Box className="flex flex-col justify-start" sx={{ marginTop: "15px" }}>
          {tabValue === 0 && <ClientSearchMeetingView clientDomain={clientDomain as string} />}
          {tabValue === 1 && <ClientActionItem clientDomain={clientDomain as string} />}
        </Box>
      </Box>
    </Box>
  );
}
export default GlobalSearchClientPage;